import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

// data-controller="bridge--cart-button"
export default class extends BridgeComponent {
  static component = "cartbutton"
  static values = { badge: Number }

  connect() {
    super.connect()
    const badge = this.getBadgeValue()
    const iosImage = this.bridgeElement.bridgeAttribute("ios-image") 
    const androidImage = this.bridgeElement.bridgeAttribute("android-image") 
    
    this.send("connect", {
      iosImage: iosImage,
      androidImage: androidImage,
      badge: badge
    }, () => this.element.click())
  }

  badgeValueChanged() {
    this.send("update", { badge: this.getBadgeValue() })
  }

  disconnect() {
    super.disconnect()
    this.send("disconnect")
  }

  // Helper method para obtener el valor del badge
  getBadgeValue() {
    return this.badgeValue || parseInt(this.bridgeElement.bridgeAttribute("badge") || "0", 10)
  }
}
